import React, { createContext, useContext } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import useSWR from "swr";
import { fetchData } from "../../lib/dashboard/data";

const MarketWatchStockContext = createContext();

const MarketWatchStockProvider = ({ children }) => {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();

  const getApiEndpoint = (path) => {
    switch (path) {
      case "/dashboard/market-watch/stocks/money_flow":
        return "/stock-market/person-money-flow";
      case "/dashboard/market-watch/stocks/buy_pressure":
        return "/stock-market/person-buy-pressure";
      case "/dashboard/market-watch/stocks/buy_value":
        return "/stock-market/person-buy-value";
      case "/dashboard/market-watch/stocks/buy_ratio":
        return "/stock-market/buy-order-ratio";
      case "/dashboard/market-watch/stocks/sell_ratio":
        return "/stock-market/sell-order-ratio";
      case "/dashboard/market-watch/stocks/value_change":
        return "/stock-market/value-change";
      default:
        return null;
    }
  };

  const apiEndpoint = getApiEndpoint(pathname);
  const tableParams = searchParams.get("table");
  const tableData = useSWR(`${apiEndpoint}?table=${tableParams}`, fetchData, {
    dedupingInterval: 60000,
  });

  const highlightedCols = [
    "money_flow",
    "closing_price_change",
    "last_price_change",
  ];

  return (
    <MarketWatchStockContext.Provider
      value={{
        tableData,
        highlightedCols,
      }}
    >
      {children}
    </MarketWatchStockContext.Provider>
  );
};

export default MarketWatchStockProvider;

export const useMarketWatchStockContext = () =>
  useContext(MarketWatchStockContext);
